if ($('#orderNow').length > 0) {
    $('.btn:not(.cta)').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#orderNow").offset().top
        }, 1200);
    })
}